import { css } from '@emotion/css';

const container = css({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: 'var(--spacings-0) 0',
  margin: 'var(--spacings-0) var(--spacings-0) 0',
  borderBottom: '1px solid var(--colors-neutral-200)',
  '&.MuiListSubheader-root': {
    color: 'var(--colors-neutral-400)',
    font: 'var(--text-typography-caption)',
  },
});

const infoIcon = css({
  color: 'var(--colors-neutral-300)',
});

const GroupHeaderStyles = {
  container,
  infoIcon,
};

export default GroupHeaderStyles;
